import { useEffect } from "react";

const IDealResult = ({ link }) => {
    useEffect(() => {
        if (link) {
            window.open(link, '_blank');
        }
    }, [link]);

    return null;  
};

export default IDealResult;
